// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { BiStar } from "react-icons/bi";
// import { AiFillStar, AiOutlineStar } from "react-icons/ai";
// import { MdOutlineGridView, MdViewList } from "react-icons/md";
// import { Link, useNavigate } from "react-router-dom";
// import apiKey from "../config/apiKey";

// // 🇵🇰 Top Cities for O/A Level Tutoring in Pakistan
// const CITIES_PK = [
//   "Karachi",
//   "Lahore",
//   "Islamabad",
//   "Rawalpindi",
//   "Faisalabad",
//   "Multan",
//   "Gujranwala",
//   "Peshawar",
//   "Quetta",
//   "Sialkot",
//   "Hyderabad",
//   "Abbottabad",
//   "Bahawalpur",
//   "Sukkur",
//   "Mirpur (AJK)",
// ];

// // normalize helper
// const norm = (v) =>
//   (v || "")
//     .toString()
//     .toLowerCase()
//     .normalize("NFKD")
//     .replace(/[\u0300-\u036f]/g, "")
//     .replace(/\s+/g, " ")
//     .trim();

// const ShowAllTeachers = () => {
//   const [isGridView, setIsGridView] = useState(true);
//   const [teachers, setTeachers] = useState([]);
//   const [filteredTeachers, setFilteredTeachers] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [mySubjects, setMySubjects] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Filters
//   const [cityFilter, setCityFilter] = useState("");     // NEW: city filter
//   const [typeFilter, setTypeFilter] = useState("");     // Online/Home/Both
//   const [classFilter, setClassFilter] = useState("");
//   const [subjectFilter, setSubjectFilter] = useState("");
//   const [fee, setFee] = useState(10000);
//   const [searchName, setSearchName] = useState("");
//   const [searchPlace, setSearchPlace] = useState("");

//   // Debounce name/place
//   const [debouncedName, setDebouncedName] = useState("");
//   const [debouncedPlace, setDebouncedPlace] = useState("");

//   useEffect(() => {
//     const t = setTimeout(() => setDebouncedName(searchName), 250);
//     return () => clearTimeout(t);
//   }, [searchName]);

//   useEffect(() => {
//     const t = setTimeout(() => setDebouncedPlace(searchPlace), 250);
//     return () => clearTimeout(t);
//   }, [searchPlace]);

//   const matchesName = (teacher, term) => {
//     const q = norm(term);
//     if (!q) return true;
//     return norm(teacher.teacher_name).includes(q);
//   };

//   const matchesPlace = (teacher, term) => {
//     const q = norm(term);
//     if (!q) return true;
//     if (norm(teacher.location).includes(q)) return true;
//     if (Array.isArray(teacher.locations)) {
//       for (const l of teacher.locations) {
//         if (norm(l?.location_text).includes(q)) return true;
//       }
//     }
//     return false;
//   };

//   // Fetch
//   useEffect(() => {
//     setLoading(true);

//     axios
//       .get(`${apiKey}/api/edolutions/teachers/all`, {})
//       .then((response) => {
//         const data = response.data.data || [];
//         setTeachers(data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching teachers:", err);
//         setError("No Teacher found related to your selected subject");
//         setLoading(false);
//       });

//     axios
//       .get(`${apiKey}/api/edolutions/classes`, {})
//       .then((res) => setClasses(res.data || []))
//       .catch((err) => console.error(err));
//   }, []);

//   const getTeacherPrice = (teacher) => {
//     if (subjectFilter) {
//       const subject = teacher.subjects?.find((sub) => sub.subject === subjectFilter);
//       return subject ? subject.online_charges || subject.home_charges : null;
//     } else {
//       const first = teacher.subjects?.find((sub) => sub.online_charges || sub.home_charges);
//       return first ? first.online_charges || first.home_charges : null;
//     }
//   };

//   // get subjects for selected class id
//   const handleClassChange = (e) => {
//     const selectedClassName = e.target.value.trim().toLowerCase();
//     const selectedClassId =
//       e.target.options[e.target.selectedIndex].getAttribute("data-classid");

//     setClassFilter(selectedClassName);

//     axios
//       .get(`${apiKey}/api/edolutions/classes/${selectedClassId}`, {})
//       .then((res) => setMySubjects(res.data || []))
//       .catch((err) => console.error("Error fetching subjects:", err));
//   };

//   // Core filter logic
//   const applyFilters = () => {
//     let filtered = [...teachers];

//     // City filter (prefers teacher.city; falls back to legacy location text)
//     if (cityFilter) {
//       const cf = norm(cityFilter);
//       filtered = filtered.filter((teacher) => {
//         const tCity = norm(teacher.city);
//         const tLoc = norm(teacher.location);
//         const cityHit = tCity ? tCity === cf : false;
//         const legacyHit = tLoc ? tLoc.includes(cf) : false;
//         return cityHit || legacyHit;
//       });
//     }

//     // Type filter (online/home/both)
//     if (typeFilter) {
//       filtered = filtered.filter((teacher) => {
//         const type = teacher.type_name?.trim().toLowerCase();
//         const filter = typeFilter.trim().toLowerCase();
//         return type === filter || type === "both";
//       });
//     }

//     // Class filter
//     if (classFilter) {
//       filtered = filtered.filter((teacher) =>
//         teacher.subjects?.some(
//           (subject) =>
//             subject.class_name &&
//             subject.class_name.trim().toLowerCase() === classFilter
//         )
//       );
//     }

//     // Subject filter
//     if (subjectFilter) {
//       filtered = filtered.filter((teacher) =>
//         teacher.subjects?.some(
//           (subject) =>
//             subject.subject &&
//             subject.subject.trim().toLowerCase() === subjectFilter.trim().toLowerCase()
//         )
//       );
//     }

//     // Fee
//     filtered = filtered.filter((teacher) => {
//       const price = Number(getTeacherPrice(teacher));
//       return !isNaN(price) && price <= Number(fee);
//     });

//     // Name + Place
//     filtered = filtered
//       .filter((t) => matchesName(t, debouncedName || searchName))
//       .filter((t) => matchesPlace(t, debouncedPlace || searchPlace));

//     setFilteredTeachers(filtered);
//   };

//   // Apply when filters or data change
//   useEffect(() => {
//     if (teachers.length > 0) applyFilters();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [teachers, cityFilter, typeFilter, classFilter, subjectFilter, fee, debouncedName, debouncedPlace]);

//   const clearAllFilters = () => {
//     setCityFilter("");
//     setTypeFilter("");
//     setClassFilter("");
//     setSubjectFilter("");
//     setFee(10000);
//     setSearchName("");
//     setSearchPlace("");
//   };

//   const toggleView = () => setIsGridView((v) => !v);

//   const [currentPage, setCurrentPage] = useState(1);
//   const teachersPerPage = 12;
//   const indexOfLastTeacher = currentPage * teachersPerPage;
//   const currentTeachers = filteredTeachers.slice(0, indexOfLastTeacher);
//   const loadMoreTeachers = () => setCurrentPage((p) => p + 1);

//   const navigate = useNavigate();

//   // --- UI helpers: filter chips summary
//   const chips = [
//     cityFilter && { label: `City: ${cityFilter}`, onClear: () => setCityFilter("") },
//     typeFilter && { label: `Type: ${typeFilter}`, onClear: () => setTypeFilter("") },
//     classFilter && { label: `Class: ${classFilter}`, onClear: () => setClassFilter("") },
//     subjectFilter && { label: `Subject: ${subjectFilter}`, onClear: () => setSubjectFilter("") },
//     (searchName && { label: `Name: ${searchName}`, onClear: () => setSearchName("") }),
//     (searchPlace && { label: `Place: ${searchPlace}`, onClear: () => setSearchPlace("") }),
//     fee !== 10000 && { label: `Fee ≤ ${fee}`, onClear: () => setFee(10000) },
//   ].filter(Boolean);

//   // Collapsible filters on mobile
//   const [showFilters, setShowFilters] = useState(true);

//   return (
//     <div className="relative flex flex-col break-words w-[90%] mx-auto mb-6 bg-white rounded-lg p-4 md:p-8 border-0">
//       {/* Header */}
//       <div className="mx-auto mb-8 md:mb-12 text-center">
//         <p className="text-2xl md:text-4xl font-extrabold text-black">
//           Meet Our Expert Educators Shaping Bright Futures
//         </p>
//         <p className="my-3 text-gray-600">
//           Dedicated Professionals Committed To Your Learning Journey
//         </p>
//       </div>

//       {/* View toggle + Filters toggle */}
//       <div className="flex items-center justify-between mb-4">
//         <div className="flex gap-2">
//           <button
//             onClick={() => setShowFilters((s) => !s)}
//             className="px-3 py-2 text-sm border rounded-md hover:bg-gray-50"
//           >
//             {showFilters ? "Hide Filters" : "Show Filters"}
//           </button>
//         </div>
//         <div className="flex gap-2">
//           <button
//             onClick={toggleView}
//             className={`p-2 rounded-md border ${isGridView ? "bg-gray-100" : "bg-white"}`}
//             title="Grid view"
//           >
//             <MdOutlineGridView />
//           </button>
//           <button
//             onClick={toggleView}
//             className={`p-2 rounded-md border ${!isGridView ? "bg-gray-100" : "bg-white"}`}
//             title="List view"
//           >
//             <MdViewList />
//           </button>
//         </div>
//       </div>

//       {/* Filter bar */}
//       {showFilters && (
//         <div className="w-full border rounded-xl p-4 md:p-5 bg-gray-50">
//           {/* Row 1: City, Class, Subject, Type */}
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
//             {/* City Filter */}
//             <select
//               value={cityFilter}
//               onChange={(e) => setCityFilter(e.target.value)}
//               className="border px-3 py-2 rounded-md bg-white"
//             >
//               <option value="">Select City</option>
//               {CITIES_PK.map((c) => (
//                 <option key={c} value={c}>
//                   {c}
//                 </option>
//               ))}
//             </select>

//             {/* Class Filter */}
//             <select
//               onChange={handleClassChange}
//               className="border px-3 py-2 rounded-md bg-white"
//               value={classes.find((c) => c.class_name?.toLowerCase().trim() === classFilter)?.class_name || ""}
//             >
//               <option value="">Select Class</option>
//               {classes.map((classItem) => (
//                 <option
//                   key={classItem.id}
//                   value={classItem.class_name}
//                   data-classid={classItem.id}
//                 >
//                   {classItem.class_name}
//                 </option>
//               ))}
//             </select>

//             {/* Subject Filter */}
//             <select
//               value={subjectFilter}
//               onChange={(e) => setSubjectFilter(e.target.value)}
//               className="border px-3 py-2 rounded-md bg-white"
//             >
//               <option value="">Select Subject</option>
//               {mySubjects.map((subject) => (
//                 <option key={subject.id} value={subject.subject_name}>
//                   {subject.subject_name}
//                 </option>
//               ))}
//             </select>

//             {/* Type Filter */}
//             <select
//               value={typeFilter}
//               onChange={(e) => setTypeFilter(e.target.value)}
//               className="border px-3 py-2 rounded-md bg-white"
//             >
//               <option value="">Select Type</option>
//               <option value="online">Online</option>
//               <option value="home">Home</option>
//             </select>
//           </div>

//           {/* Row 2: Name, Place, Fee, Clear */}
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mt-3">
//             <input
//               type="text"
//               placeholder="Search by teacher name…"
//               value={searchName}
//               onChange={(e) => setSearchName(e.target.value)}
//               className="border px-3 py-2 rounded-md"
//             />

//             <input
//               type="text"
//               placeholder="Search by place/area (e.g., DHA, Johar)…"
//               value={searchPlace}
//               onChange={(e) => setSearchPlace(e.target.value)}
//               className="border px-3 py-2 rounded-md"
//             />

//            <div className="flex items-center gap-3 px-2 py-2 border rounded-md bg-white">
//   <span className="text-sm text-gray-600">Fee</span>
//   <input
//     type="range"
//     min="500"
//     step="500"
//     max="10000"
//     value={fee}
//     onChange={(e) => setFee(e.target.value)}
//     style={{
//       background: `linear-gradient(90deg, #1ccc9e ${
//         ((fee - 500) / 9500) * 100
//       }%, #ddd ${((fee - 500) / 9500) * 100}%)`,
//       WebkitAppearance: "none",
//       width: "100%",
//       height: "8px",
//       borderRadius: "5px",
//       outline: "none",
//     }}
//     className="range-slider"
//   />
//   <span className="text-sm text-gray-700 whitespace-nowrap">≤ Rs. {fee}</span>
// </div>


//             <button
//               onClick={clearAllFilters}
//               className="px-4 py-2 border text-sm h-10 hover:border-[#2dd0a5] text-gray-700 rounded-md bg-white"
//             >
//               Clear All Filters
//             </button>
//           </div>

//           {/* Filter chips summary */}
//           {chips.length > 0 && (
//             <div className="flex flex-wrap gap-2 mt-4">
//               {chips.map((c, idx) => (
//                 <span
//                   key={idx}
//                   className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm bg-white border"
//                 >
//                   {c.label}
//                   <button
//                     onClick={c.onClear}
//                     className="text-gray-500 hover:text-black"
//                     title="Remove"
//                   >
//                     ✕
//                   </button>
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       {/* Loader / Empty */}
//       {loading ? (
//         <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//           <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
//           <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">Edolution...</p>
//         </div>
//       ) : filteredTeachers.length === 0 ? (
//         <div className="text-center text-gray-600 mt-10">No teachers found matching the criteria.</div>
//       ) : (
//         <>
//           {/* Cards/List */}
//           <div
//             className={
//               isGridView
//                 ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mx-auto mt-6"
//                 : "flex flex-col gap-6 justify-center items-center mt-6"
//             }
//           >
//             {currentTeachers.map((teacher) => (
//               <div key={teacher.user_id} className="w-full flex justify-center">
//                 <Link to={`/Teacherprof/${teacher.user_id}`} className="w-full flex justify-center">
//                   <div className="bg-white shadow-sm hover:shadow-md transition w-64 rounded-lg overflow-hidden flex flex-col items-center pt-4 border">
//                     <img
//                       src={
//                         teacher.photo
//                           ? `${apiKey}/userProfile/${teacher.photo}`
//                           : `${apiKey}/userProfile/87654321.png`
//                       }
//                       alt={teacher.teacher_name || "Teacher profile picture"}
//                       className="rounded-full border w-24 h-24 object-cover"
//                     />
//                     <div className="p-4 text-center w-full">
//                       <h3 className="text-lg font-semibold capitalize">{teacher.teacher_name}</h3>
//                       {/* City label */}
//                       {teacher.city && (
//                         <p className="text-xs text-gray-500 mt-1">{teacher.city}</p>
//                       )}
//                       {/* Price */}
//                       <p className="text-sm font-medium capitalize mt-1">
//                         Rs. {getTeacherPrice(teacher) || "-"} / hour
//                       </p>
//                       {/* Rating */}
//                       <div className="flex items-center justify-center mt-2">
//                         {[1, 2, 3, 4, 5].map((star) =>
//                           teacher.average_rating >= star ? (
//                             <AiFillStar key={star} className="h-4 w-4 text-yellow-500" />
//                           ) : (
//                             <AiOutlineStar key={star} className="h-4 w-4 text-gray-300" />
//                           )
//                         )}
//                         {teacher.total_reviews > 0 && (
//                           <span className="ml-2 text-xs text-gray-500">
//                             ({teacher.total_reviews})
//                           </span>
//                         )}
//                       </div>

//                       <Link
//                         to={`/Teacherprof/${teacher.user_id}`}
//                         className="text-[#1ccc9e] text-sm mt-3 inline-block"
//                       >
//                         View Profile
//                       </Link>
//                     </div>
//                   </div>
//                 </Link>
//               </div>
//             ))}
//           </div>

//           {/* Load More */}
//           {currentTeachers.length < filteredTeachers.length && (
//             <div className="mt-6 text-center">
//               <button
//                 onClick={loadMoreTeachers}
//                 className="px-4 py-2 bg-[#2dd0a5] text-white rounded-md"
//               >
//                 Load More
//               </button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default ShowAllTeachers;



// ✅ COMPLETE DROP-IN UPDATED CODE (ShowAllTeachers.jsx)
// ✅ Adds ONLY COUNTRY filter (react-select + country-state-city)
// ✅ Keeps your existing CITY filter exactly as-is (cityFilter dropdown with CITIES_PK)
// ✅ All old filters/functionality remain same

import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { BiStar } from "react-icons/bi";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { MdOutlineGridView, MdViewList } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import apiKey from "../config/apiKey";

// ✅ NEW
import Select from "react-select";
import { Country } from "country-state-city";

// 🇵🇰 Top Cities for O/A Level Tutoring in Pakistan
const CITIES_PK = [
  "Karachi",
  "Lahore",
  "Islamabad",
  "Rawalpindi",
  "Faisalabad",
  "Multan",
  "Gujranwala",
  "Peshawar",
  "Quetta",
  "Sialkot",
  "Hyderabad",
  "Abbottabad",
  "Bahawalpur",
  "Sukkur",
  "Mirpur (AJK)",
];

// normalize helper
const norm = (v) =>
  (v || "")
    .toString()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const ShowAllTeachers = () => {
  const [isGridView, setIsGridView] = useState(true);
  const [teachers, setTeachers] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [mySubjects, setMySubjects] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Filters
  const [cityFilter, setCityFilter] = useState(""); // ✅ keep as-is (Pakistan cities dropdown)
  const [typeFilter, setTypeFilter] = useState(""); // Online/Home/Both
  const [classFilter, setClassFilter] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("");
  const [fee, setFee] = useState(10000);
  const [searchName, setSearchName] = useState("");
  const [searchPlace, setSearchPlace] = useState("");

  // ✅ NEW: Country filter
  const [countryCode, setCountryCode] = useState(""); // PK, AE, SA...
  const [countryName, setCountryName] = useState(""); // Pakistan, UAE...

  // Debounce name/place
  const [debouncedName, setDebouncedName] = useState("");
  const [debouncedPlace, setDebouncedPlace] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setDebouncedName(searchName), 250);
    return () => clearTimeout(t);
  }, [searchName]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedPlace(searchPlace), 250);
    return () => clearTimeout(t);
  }, [searchPlace]);

  const matchesName = (teacher, term) => {
    const q = norm(term);
    if (!q) return true;
    return norm(teacher.teacher_name).includes(q);
  };

  const matchesPlace = (teacher, term) => {
    const q = norm(term);
    if (!q) return true;
    if (norm(teacher.location).includes(q)) return true;
    if (Array.isArray(teacher.locations)) {
      for (const l of teacher.locations) {
        if (norm(l?.location_text).includes(q)) return true;
      }
    }
    return false;
  };

  // ✅ NEW: Allowed countries list (same as your signup requirement)
  const allowedCountries = useMemo(
    () => ["PK", "SA", "AE", "QA", "BH", "OM", "GB", "US", "AU", "CA"],
    []
  );

  // ✅ NEW: react-select options
  const countryOptions = useMemo(() => {
    return Country.getAllCountries()
      .filter((c) => allowedCountries.includes(c.isoCode))
      .map((c) => ({ value: c.isoCode, label: c.name }));
  }, [allowedCountries]);

  // ✅ NEW: styles (simple & consistent)
  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      borderRadius: "0.375rem",
      borderColor: "#d1d5db",
      boxShadow: "none",
      cursor: "pointer",
      backgroundColor: "#fff",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };

  // Fetch
  useEffect(() => {
    setLoading(true);

    axios
      .get(`${apiKey}/api/edolutions/teachers/all`, {})
      .then((response) => {
        const data = response.data.data || [];
        setTeachers(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching teachers:", err);
        setError("No Teacher found related to your selected subject");
        setLoading(false);
      });

    axios
      .get(`${apiKey}/api/edolutions/classes`, {})
      .then((res) => setClasses(res.data || []))
      .catch((err) => console.error(err));
  }, []);

  const getTeacherPrice = (teacher) => {
    if (subjectFilter) {
      const subject = teacher.subjects?.find(
        (sub) => sub.subject === subjectFilter
      );
      return subject ? subject.online_charges || subject.home_charges : null;
    } else {
      const first = teacher.subjects?.find(
        (sub) => sub.online_charges || sub.home_charges
      );
      return first ? first.online_charges || first.home_charges : null;
    }
  };

  // get subjects for selected class id
  const handleClassChange = (e) => {
    const selectedClassName = e.target.value.trim().toLowerCase();
    const selectedClassId =
      e.target.options[e.target.selectedIndex].getAttribute("data-classid");

    setClassFilter(selectedClassName);

    axios
      .get(`${apiKey}/api/edolutions/classes/${selectedClassId}`, {})
      .then((res) => setMySubjects(res.data || []))
      .catch((err) => console.error("Error fetching subjects:", err));
  };

  // Core filter logic
  const applyFilters = () => {
    let filtered = [...teachers];

    // ✅ NEW: Country filter
    // Priority: teacher.country if backend provides
    // Fallback: check teacher.location / teacher.locations[].location_text
    if (countryCode) {
      const cf = norm(countryName);
      filtered = filtered.filter((teacher) => {
        if (teacher.country && norm(teacher.country) === cf) return true;

        if (norm(teacher.location).includes(cf)) return true;

        if (Array.isArray(teacher.locations)) {
          return teacher.locations.some((l) =>
            norm(l?.location_text).includes(cf)
          );
        }
        return false;
      });
    }

    // ✅ City filter (KEEP AS-IS)
    if (cityFilter) {
      const cf = norm(cityFilter);
      filtered = filtered.filter((teacher) => {
        const tCity = norm(teacher.city);
        const tLoc = norm(teacher.location);
        const cityHit = tCity ? tCity === cf : false;
        const legacyHit = tLoc ? tLoc.includes(cf) : false;
        return cityHit || legacyHit;
      });
    }

    // Type filter (online/home/both)
    if (typeFilter) {
      filtered = filtered.filter((teacher) => {
        const type = teacher.type_name?.trim().toLowerCase();
        const filter = typeFilter.trim().toLowerCase();
        return type === filter || type === "both";
      });
    }

    // Class filter
    if (classFilter) {
      filtered = filtered.filter((teacher) =>
        teacher.subjects?.some(
          (subject) =>
            subject.class_name &&
            subject.class_name.trim().toLowerCase() === classFilter
        )
      );
    }

    // Subject filter
    if (subjectFilter) {
      filtered = filtered.filter((teacher) =>
        teacher.subjects?.some(
          (subject) =>
            subject.subject &&
            subject.subject.trim().toLowerCase() ===
              subjectFilter.trim().toLowerCase()
        )
      );
    }

    // Fee
    filtered = filtered.filter((teacher) => {
      const price = Number(getTeacherPrice(teacher));
      return !isNaN(price) && price <= Number(fee);
    });

    // Name + Place
    filtered = filtered
      .filter((t) => matchesName(t, debouncedName || searchName))
      .filter((t) => matchesPlace(t, debouncedPlace || searchPlace));

    setFilteredTeachers(filtered);
  };

  // Apply when filters or data change
  useEffect(() => {
    if (teachers.length > 0) applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    teachers,
    countryCode,
    countryName,
    cityFilter,
    typeFilter,
    classFilter,
    subjectFilter,
    fee,
    debouncedName,
    debouncedPlace,
  ]);

  const clearAllFilters = () => {
    // ✅ reset country too
    setCountryCode("");
    setCountryName("");

    setCityFilter("");
    setTypeFilter("");
    setClassFilter("");
    setSubjectFilter("");
    setFee(10000);
    setSearchName("");
    setSearchPlace("");
  };

  const toggleView = () => setIsGridView((v) => !v);

  const [currentPage, setCurrentPage] = useState(1);
  const teachersPerPage = 12;
  const indexOfLastTeacher = currentPage * teachersPerPage;
  const currentTeachers = filteredTeachers.slice(0, indexOfLastTeacher);
  const loadMoreTeachers = () => setCurrentPage((p) => p + 1);

  const navigate = useNavigate();

  // --- UI helpers: filter chips summary
  const chips = [
    countryName && {
      label: `Country: ${countryName}`,
      onClear: () => {
        setCountryCode("");
        setCountryName("");
      },
    },
    cityFilter && { label: `City: ${cityFilter}`, onClear: () => setCityFilter("") },
    typeFilter && { label: `Type: ${typeFilter}`, onClear: () => setTypeFilter("") },
    classFilter && { label: `Class: ${classFilter}`, onClear: () => setClassFilter("") },
    subjectFilter && { label: `Subject: ${subjectFilter}`, onClear: () => setSubjectFilter("") },
    (searchName && { label: `Name: ${searchName}`, onClear: () => setSearchName("") }),
    (searchPlace && { label: `Place: ${searchPlace}`, onClear: () => setSearchPlace("") }),
    fee !== 10000 && { label: `Fee ≤ ${fee}`, onClear: () => setFee(10000) },
  ].filter(Boolean);

  // Collapsible filters on mobile
  const [showFilters, setShowFilters] = useState(true);

  return (
    <div className="relative flex flex-col break-words w-[90%] mx-auto mb-6 bg-white rounded-lg p-4 md:p-8 border-0">
      {/* Header */}
      <div className="mx-auto mb-8 md:mb-12 text-center">
        <p className="text-2xl md:text-4xl font-extrabold text-black">
          Meet Our Expert Educators Shaping Bright Futures
        </p>
        <p className="my-3 text-gray-600">
          Dedicated Professionals Committed To Your Learning Journey
        </p>
      </div>

      {/* View toggle + Filters toggle */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2">
          <button
            onClick={() => setShowFilters((s) => !s)}
            className="px-3 py-2 text-sm border rounded-md hover:bg-gray-50"
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={toggleView}
            className={`p-2 rounded-md border ${isGridView ? "bg-gray-100" : "bg-white"}`}
            title="Grid view"
          >
            <MdOutlineGridView />
          </button>
          <button
            onClick={toggleView}
            className={`p-2 rounded-md border ${!isGridView ? "bg-gray-100" : "bg-white"}`}
            title="List view"
          >
            <MdViewList />
          </button>
        </div>
      </div>

      {/* Filter bar */}
      {showFilters && (
        <div className="w-full border rounded-xl p-4 md:p-5 bg-gray-50">
          {/* Row 1: City, Class, Subject, Type (+ Country) */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
            {/* ✅ NEW Country Filter */}
            <div className="bg-white rounded-md">
              <Select
                styles={selectStyles}
                options={countryOptions}
                placeholder="Select Country"
                isClearable
                value={
                  countryCode
                    ? countryOptions.find((o) => o.value === countryCode)
                    : null
                }
                onChange={(opt) => {
                  setCountryCode(opt?.value || "");
                  setCountryName(opt?.label || "");

                  // optional: If country not Pakistan, clear cityFilter (your choice)
                  // If you want to keep city filter always, comment next 3 lines
                  if ((opt?.value || "") !== "PK") {
                    setCityFilter("");
                  }
                }}
              />
            </div>

            {/* City Filter (as-is) */}
            <select
              value={cityFilter}
              onChange={(e) => setCityFilter(e.target.value)}
              className="border px-3 py-2 rounded-md bg-white"
              disabled={countryCode && countryCode !== "PK"} // ✅ only active for Pakistan
              title={countryCode && countryCode !== "PK" ? "City filter is only for Pakistan" : ""}
            >
              <option value="">
                {countryCode && countryCode !== "PK" ? "City (Pakistan only)" : "Select City"}
              </option>
              {CITIES_PK.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>

            {/* Class Filter */}
            <select
              onChange={handleClassChange}
              className="border px-3 py-2 rounded-md bg-white"
              value={
                classes.find((c) => c.class_name?.toLowerCase().trim() === classFilter)
                  ?.class_name || ""
              }
            >
              <option value="">Select Class</option>
              {classes.map((classItem) => (
                <option
                  key={classItem.id}
                  value={classItem.class_name}
                  data-classid={classItem.id}
                >
                  {classItem.class_name}
                </option>
              ))}
            </select>

            {/* Subject Filter */}
            <select
              value={subjectFilter}
              onChange={(e) => setSubjectFilter(e.target.value)}
              className="border px-3 py-2 rounded-md bg-white"
            >
              <option value="">Select Subject</option>
              {mySubjects.map((subject) => (
                <option key={subject.id} value={subject.subject_name}>
                  {subject.subject_name}
                </option>
              ))}
            </select>

            {/* Type Filter */}
            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              className="border px-3 py-2 rounded-md bg-white"
            >
              <option value="">Select Type</option>
              <option value="online">Online</option>
              <option value="home">Home</option>
            </select>
          </div>

          {/* Row 2: Name, Place, Fee, Clear */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mt-3">
            <input
              type="text"
              placeholder="Search by teacher name…"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              className="border px-3 py-2 rounded-md"
            />

            <input
              type="text"
              placeholder="Search by place/area (e.g., DHA, Johar)…"
              value={searchPlace}
              onChange={(e) => setSearchPlace(e.target.value)}
              className="border px-3 py-2 rounded-md"
            />

            <div className="flex items-center gap-3 px-2 py-2 border rounded-md bg-white">
              <span className="text-sm text-gray-600">Fee</span>
              <input
                type="range"
                min="500"
                step="500"
                max="10000"
                value={fee}
                onChange={(e) => setFee(e.target.value)}
                style={{
                  background: `linear-gradient(90deg, #1ccc9e ${
                    ((fee - 500) / 9500) * 100
                  }%, #ddd ${((fee - 500) / 9500) * 100}%)`,
                  WebkitAppearance: "none",
                  width: "100%",
                  height: "8px",
                  borderRadius: "5px",
                  outline: "none",
                }}
                className="range-slider"
              />
              <span className="text-sm text-gray-700 whitespace-nowrap">≤ Rs. {fee}</span>
            </div>

            <button
              onClick={clearAllFilters}
              className="px-4 py-2 border text-sm h-10 hover:border-[#2dd0a5] text-gray-700 rounded-md bg-white"
            >
              Clear All Filters
            </button>
          </div>

          {/* Filter chips summary */}
          {chips.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-4">
              {chips.map((c, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm bg-white border"
                >
                  {c.label}
                  <button
                    onClick={c.onClear}
                    className="text-gray-500 hover:text-black"
                    title="Remove"
                  >
                    ✕
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Loader / Empty */}
      {loading ? (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
          <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#2DD0A5]"></div>
          <p className="mt-4 text-lg font-semibold text-[#2dd0a5]">Edolution...</p>
        </div>
      ) : filteredTeachers.length === 0 ? (
        <div className="text-center text-gray-600 mt-10">No teachers found matching the criteria.</div>
      ) : (
        <>
          {/* Cards/List */}
          <div
            className={
              isGridView
                ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mx-auto mt-6"
                : "flex flex-col gap-6 justify-center items-center mt-6"
            }
          >
            {currentTeachers.map((teacher) => (
              <div key={teacher.user_id} className="w-full flex justify-center">
                <Link to={`/Teacherprof/${teacher.user_id}`} className="w-full flex justify-center">
                  <div className="bg-white shadow-sm hover:shadow-md transition w-64 rounded-lg overflow-hidden flex flex-col items-center pt-4 border">
                    <img
                      src={
                        teacher.photo
                          ? `${apiKey}/userProfile/${teacher.photo}`
                          : `${apiKey}/userProfile/87654321.png`
                      }
                      alt={teacher.teacher_name || "Teacher profile picture"}
                      className="rounded-full border w-24 h-24 object-cover"
                    />
                    <div className="p-4 text-center w-full">
                      <h3 className="text-lg font-semibold capitalize">{teacher.teacher_name}</h3>

                      {/* City label */}
                      {teacher.city && (
                        <p className="text-xs text-gray-500 mt-1">{teacher.city}</p>
                      )}

                      {/* Price */}
                      <p className="text-sm font-medium capitalize mt-1">
                        Rs. {getTeacherPrice(teacher) || "-"} / hour
                      </p>

                      {/* Rating */}
                      <div className="flex items-center justify-center mt-2">
                        {[1, 2, 3, 4, 5].map((star) =>
                          teacher.average_rating >= star ? (
                            <AiFillStar key={star} className="h-4 w-4 text-yellow-500" />
                          ) : (
                            <AiOutlineStar key={star} className="h-4 w-4 text-gray-300" />
                          )
                        )}
                        {teacher.total_reviews > 0 && (
                          <span className="ml-2 text-xs text-gray-500">
                            ({teacher.total_reviews})
                          </span>
                        )}
                      </div>

                      <Link
                        to={`/Teacherprof/${teacher.user_id}`}
                        className="text-[#1ccc9e] text-sm mt-3 inline-block"
                      >
                        View Profile
                      </Link>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {/* Load More */}
          {currentTeachers.length < filteredTeachers.length && (
            <div className="mt-6 text-center">
              <button
                onClick={() => setCurrentPage((p) => p + 1)}
                className="px-4 py-2 bg-[#2dd0a5] text-white rounded-md"
              >
                Load More
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ShowAllTeachers;
